import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import Page from '../../components/page/page';
import Intro from '../../components/intro/intro';
import Help from '../../components/help/help';
import Partners from '../../components/partners/partners';
import Social from '../../components/social/social';
import Confirmation from '../../components/confirmation/confirmation';
import { useSearchParams } from 'react-router-dom';
import { REFERENCE_NO_PARAM } from '../../helpers/network';

interface IConfirmationProps extends WithTranslation {}

const ConfirmationPage = (props: IConfirmationProps) => {
    const { t } = props;
    const [searchParams] = useSearchParams();
    const referenceNo = searchParams.get(REFERENCE_NO_PARAM) ?? '';

    const pageContent = (
        <>
            <div className="confirmation-component">
                <Intro />
            </div>
            <div className="confirmation-component">
                <h1 className="confirmation-response__title">{t('confirmation_response')}</h1>
            </div>
            <div className="confirmation-component confirmation-container">
                <Confirmation confirmationId={referenceNo} />
            </div>
            <div className="confirmation-component">
                <Help />
            </div>
            <div className="confirmation-component">
                <Partners />
            </div>
            <div className="confirmation-component">
                <Social />
            </div>
        </>
    );
    return <Page pageTitle={t('confirmation_page_title')} pageContent={pageContent} />;
};

export default withTranslation()(ConfirmationPage);
